export default "__VITE_ASSET__DwIhN8kX__"